import React from 'react'
import BlaBlaHead from '../blabla/BlaBlaHead';
import LyftTeamlogo from "../LyftClone/LyftTeamlogo";
import OnDemandFuture from "./OnDemandFuture";
import OnDemandChoose from "./OnDemandChoose";
import OnDemandCount from "./OnDemandCount";
import OnDemandFeature from "./OnDemandFeature";
import OnDemandBuild from "./OnDemandBuild";
import OnDemandGlobal from "./OnDemandGlobal";
import OnDemandAllin from "./OnDemandAllin";
import OnDemandWork from "./OnDemandWork";
import OnDemandPlateform from "./OnDemandPlateform";
import GroceryMarket from "../groceryApp/GroceryMarket";
import OnDemandFriendly from "./OnDemandFriendly";
import ShuttleAppreciation from "../../shuttle_software/ShuttleAppreciation";
import TaxiFaq from "../../taxiDispatchSoftware/TaxiFaq";

const HeadData = {
  title: "Everything You Need to Deliver On Demand",
  description: "From order management to live tracking, optimize every stage of your delivery operations.",
  image: "/assets/home/ondemand-banner.webp",
  backImage: "/assets/home/ondemand-banner-back.webp",
  btn: "Build Your App",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "On-Demand Delivery App",
        slug: ""
      },
    ]
  }
};

const ondemandChooseData = {
  titlePart1: "Why Choose",
  titlePart2: "Mobility Infotech?",
  description: "Mobility Infotech empowers businesses with robust white-label on-demand delivery solutions backed by proven technology, seamless customization, and accelerated deployment. This enables sustainable growth and operational excellence in dynamic markets.",
  boxes: [
    {
      image: "/assets/home/ondemand-choose-1.webp",
      heading: "Proven Expertise",
      description: "Backed by deep industry knowledge, our experienced development team delivers reliable, high-performance delivery applications that support business innovation and long-term success.",
    },
    {
      image: "/assets/home/ondemand-choose-2.webp",
      heading: "Cloud-Based Platform",
      description: "Our cloud-powered infrastructure ensures uninterrupted access, real-time data synchronization, and consistent performance. This allows businesses to manage operations efficiently.",
    },
    {
      image: "/assets/home/ondemand-choose-3.webp",
      heading: "Customised Solutions",
      description: "We design fully customizable solutions aligned with your unique workflows, branding requirements, and customer expectations, delivering a superior user experience across platforms.",
    },
    {
      image: "/assets/home/ondemand-choose-4.webp",
      heading: "Data security",
      description: "Enterprise-grade security measures, including advanced encryption and compliance-ready protocols, safeguard sensitive business and user data at every level.",
    },
    {
      image: "/assets/home/ondemand-choose-5.webp",
      heading: "Scalable Design",
      description: "Our platforms are engineered to scale effortlessly, supporting increased users, orders, and feature expansion without sacrificing performance or reliability as demand grows.",
    },
    {
      image: "/assets/home/ondemand-choose-6.webp",
      heading: "Flexible Pricing Models",
      description: "We offer adaptable pricing structures designed to suit startups, growing businesses, and enterprises, ensuring cost efficiency without compromising quality or capabilities.",
    },
  ]
}

const featureData = {
  preHead: "Core Features of Our",
  titlePart1: "On-Demand",
  titlePart2: " Delivery App",
  subHead: "A complete set of features supporting order management, live tracking, communication, and overall delivery workflow across customer, driver, and admin apps.",
  feature1: {
    image: "/assets/home/ondemand-feature-1.webp",
    title1: "Real Time Update",
    description1: "Keep customers informed instantly with live notifications on order status, delivery progress, and key app activities.",
    title2: "Delivery Notes",
    description2: "Allow users to add custom instructions or special requests, ensuring accurate, smooth, and personalized deliveries.",
    title3: "Secure Payments",
    description3: "Integrate trusted payment gateways with end-to-end encryption to enable safe, fast, and seamless transactions.",

    title5: "Chat Support",
    description5: "Enable direct communication between customers, delivery agents, and support teams for faster issue resolution.",
    title6: "Multilingual Support",
    description6: "Expand your reach by offering the app in multiple languages to serve diverse customer groups across regions.",
    title7: "Order Tracking",
    description7: "Provide real-time order tracking with live map views, driver location updates, and accurate delivery time estimates.",
  },

  feature2: {
    image: "/assets/home/ondemand-feature-2.webp",
    title1: "Easy Onboarding",
    description1: "Enable drivers to get started quickly with a simplified registration process, intuitive interface, and guided setup.",
    title2: "Real-Time Chat",
    description2: "Support smooth communication between delivery agents, customers, and operations teams to ensure timely coordination.",
    title3: "Optimized Routes",
    description3: "Reduce delivery time and fuel costs using intelligent route recommendations based on live traffic and delivery priorities.",

    title5: "Accept and Reject Orders",
    description5: "Give delivery agents full control to accept or decline delivery requests in real time based on availability.",
    title6: "Performance Analytics",
    description6: "Track delivery performance, earnings, efficiency, and customer ratings to improve productivity and accountability.",
    title7: "Rate a Customer",
    description7: "Allow delivery agents to rate customers after each delivery, promoting transparency and a respectful delivery ecosystem.",
  },

  feature3: {
    image: "/assets/home/ondemand-feature-3.webp",
    title1: "Monitor Performance",
    description1: "Track end-to-end business performance, delivery operations, and user activity through real-time dashboards.",
    title2: "Seamless Access",
    description2: "Enable secure, role-based access for administrators, managers, and support teams across all systems.",
    title3: "Reporting and Analytics",
    description3: "Leverage detailed reports and visual analytics to make informed, data-driven business decisions.",

    title5: "Manage Offers and Promos",
    description5: "Create, schedule, and manage discounts, promo codes, and loyalty programs to increase customer engagement and sales.",
    title6: "Invoice Management",
    description6: "Generate, manage, and track digital invoices for customers, vendors, and delivery agents with accuracy and ease.",
    title7: "Content Management",
    description7: "Update banners, service categories, pricing, and in-app content efficiently through a centralized admin panel.",
  },
}

const buildData = {
  title: "Businesses We Serve With On-Demand Solutions",
  description: "We partner with startups, growing businesses, enterprises, and agencies to deliver tailored on-demand solutions that optimize operations, elevate customer experiences, and enable scalable, long-term growth.",
  boxes: [
    {
      title: "Start-Up Business",
      desc: "As a trusted on-demand app development provider, we help startups launch quickly with scalable, high-quality solutions that support rapid market entry and strong brand positioning.",
      image: "/assets/home/ondemand-build-1.webp"
    },
    {
      title: "Small & Medium Business",
      desc: "Small and mid-sized businesses adopt our on-demand platforms to improve operational efficiency, increase customer engagement, expand service reach, and integrate smoothly with existing systems.",
      image: "/assets/home/ondemand-build-2.webp"
    },
    {
      title: " Enterprise",
      desc: "We build enterprise-grade on-demand delivery and service platforms with seamless system integrations, advanced analytics, AI-driven capabilities, and multi-layered security frameworks.",
      image: "/assets/home/ondemand-build-3.webp"
    },
    {
      title: "Agencies",
      desc: "Agencies rely on Mobility Infotech for white-label on-demand app solutions that deliver consistent performance, quality, reliability, and results aligned with client goals and expectations.",
      image: "/assets/home/ondemand-build-4.webp"
    }
  ]
}

const forYouData = {
  newClass: "ondemand-for-you",
  text1: "Launch Your Branded App",
  text2: "Faster Than Ever",
  des: "Launch your on-demand app with your unique brand identity, robust features, and faster time-to-market using proven, ready-to-scale solutions from Mobility Infotech.",
  btn: "Build with us",
}

const faqData = [
  {
    id: "0",
    question: "01. What types of businesses can use Mobility Infotech’s on-demand delivery solutions?",
    answer: " Mobility Infotech’s on-demand solutions are designed for startups, small and mid-sized businesses, enterprises, and agencies. Our platforms support multiple industries including food delivery, logistics, grocery, pharmacy, home services, and more, with flexible configurations to match different operational models.",
  },
  {
    id: "1",
    question: "02. Can I fully customize the app with my own branding?",
    answer: "Yes, all on-demand apps developed by Mobility Infotech are fully white-label and customizable. You can apply your branding, logos, color schemes, workflows, and feature preferences, ensuring the app aligns perfectly with your business identity and delivers a consistent brand experience across platforms.",
  },
  {
    id: "2",
    question: "03. How long does it take to launch an on-demand app?",
    answer: "Launch timelines depend on feature requirements and customization levels. However, Mobility Infotech’s ready-to-scale architecture significantly reduces development time, allowing most businesses to launch faster than traditional builds while ensuring performance, security, and scalability from day one.",
  },
  {
    id: "3",
    question: "04. Is the platform scalable as my business grows?",
    answer: "Yes, our on-demand platform is built with scalability at its core. It supports growing user bases, higher order volumes, multiple locations, and additional features without compromising performance, stability, or user experience, making it suitable for long-term business expansion.",
  },
  {
    id: "4",
    question: "05. What kind of support does Mobility Infotech provide after launch?",
    answer: "Mobility Infotech offers ongoing technical support, maintenance, performance monitoring, and feature enhancements after launch. Our team ensures smooth operations, timely issue resolution, system updates, and continuous optimization to support your business as it scales and evolves.",
  },
];

export default function OnDemand({ initialData }) {
  return (
    <>
      <BlaBlaHead data={HeadData} />
      <LyftTeamlogo heading={true} newClass="featue-new-team" initialData={initialData?.logos}/>
      <OnDemandFuture />
      <OnDemandChoose data={ondemandChooseData} />
      <OnDemandCount />
      <OnDemandFeature data={featureData} />
      <OnDemandBuild data={buildData} />
      <OnDemandGlobal />
      <OnDemandAllin />
      <OnDemandWork filterData='taxi app' initialData={initialData?.newcasestudys}/>
      <OnDemandPlateform />
      <GroceryMarket data={forYouData} />
      <OnDemandFriendly />
      <ShuttleAppreciation initialData={initialData?.video_testimonials} />
      <div className="zip-faq-fixer">
        <TaxiFaq faqData={faqData} />
      </div>
    </>
  )
}
